import * as React from "react";

export const Pesimo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <defs>
      <style>{".b{fill:#864e20}.c{fill:#e7c930}"}</style>
    </defs>
    <rect
      width={22}
      height={22}
      x={1}
      y={1}
      rx={7.656}
      style={{
        fill: "#f8de40",
      }}
    />
    <path
      d="M7.055 7.313A1.747 1.747 0 1 0 8.8 9.059a1.747 1.747 0 0 0-1.745-1.746zm9.903 0A1.747 1.747 0 1 0 18.7 9.059a1.747 1.747 0 0 0-1.742-1.746z"
      className="b"
    />
    <path
      d="M23 13.938a14.69 14.69 0 0 1-12.406 6.531c-5.542 0-6.563-1-9.142-2.529A7.66 7.66 0 0 0 8.656 23h6.688A7.656 7.656 0 0 0 23 15.344z"
      className="c"
    />
    <path
      d="M7.3 15.353s3.75-2.125 6.625-2.312 3.906.219 2.656.5-2.906-.156-5.484.734-4.528 1.61-3.797 1.078z"
      className="b"
    />
    <path
      d="M13.585 14.614c-1.384-.09-3.474 1.357-3.474 1.357-.427.379.6-.052 1.954-.572s2.066-.015 2.7-.141.205-.558-1.18-.644z"
      className="c"
    />
  </svg>
);